import { ConsentResponse, EngagementDocumentContactMapping, EngagementPaymentMethod, EngagementStepType, MinimalEngagementHub } from '@aiwyn/api';
import { DestinationEngagementStepRef, DestinationEngagementStepType, EngagementStepPendingChanges, EngagementStepRef } from '../models';

interface EngagementAvaliabilityCheckOptions {
  engagementId?: number;
  forceRefresh?: boolean;
}
export class EngagementAvaliabilityCheck {
  static readonly type = '[EngagementsState] EngagementAvaliabilityCheck';

  constructor(public options?: EngagementAvaliabilityCheckOptions) { }
}

export class GetEngagementHub {
  static readonly type = '[EngagementsState] GetEngagementHub';

  constructor(public engagementId: number, public forceRefresh?: boolean) { }
}

export class ViewEngagement {
  static readonly type = '[EngagementsState] ViewEngagement';

  constructor(public engagementId: number) { }
}

export class SetTableSearchValue {
  static readonly type = '[EngagementsState] SetTableSearchValue';

  constructor(public searchValue: string) { }
}

export class SetSelectedEngagementId {
  static readonly type = '[EngagementsState] SetSelectedEngagementId';

  constructor(public engagementId: number) { }
}

export class SetNonInteractiveEngagement {
  static readonly type = '[EngagementsState] SetNonInteractiveEngagement';

  constructor(public engagement: MinimalEngagementHub) { }
}

export class GetEngagementDocument {
  static readonly type = '[EngagementsState] GetEngagementDocument';

  constructor(
    public fileId: number,
    public readonly documentType: Exclude<EngagementStepType, EngagementStepType.PAYMENT>,
    public readonly forceRefresh = false
  ) { }
}

export class GetEngagementConsentSettings {
  static readonly type = '[EngagementsState] GetEngagementConsentSettings';

  constructor(public documentId: number) { }
}

export class GetSelectedEngagementJobs {
  static readonly type = '[EngagementsState] GetSelectedEngagementJobs';

  constructor(public engagementId: number) { }
}

export class GetSelectedEngagementPrepayment {
  static readonly type = '[EngagementsState] GetSelectedEngagementPrepayment';

  // TODO: setStepAsFailedIfApplicable is only temporary until we implement a fully synchronous engagement prepayment flow, only show FAIL on initial load
  constructor(public engagementId: number, public setStepAsFailedIfApplicable = true) { }
}

export class SetSelectedEngagementPrepaymentAsFailed {
  static readonly type = '[EngagementsState] SetSelectedEngagementPrepaymentAsFailed';
}

// TODO Will need to check if I conditionally need to fire this
export class ConfirmEngagementViewed {
  static readonly type = '[EngagementsState] ConfirmEngagementViewed';
}

export class RemoveSelectedEngagementData {
  static readonly type = '[EngagementsState] RemoveSelectedEngagementData';
}

export class MoveToEngagementStep {
  static readonly type = '[EngagementsState] MoveToEngagementStep';

  constructor(public readonly destinationStep: DestinationEngagementStepRef | DestinationEngagementStepType) { }
}

export class SetEngagementCurrentStepRef {
  static readonly type = '[EngagementsState] SetEngagementCurrentStepRef';

  constructor(public readonly engagementId: number, public readonly ref?: EngagementStepRef) { }
}

export class UpdateSelectedDocument {
  static readonly type = '[EngagementsState] UpdateSelectedDocument';

  constructor(
    public readonly updatedDocumentBase64: string,
    public readonly documentType: Exclude<EngagementStepType, EngagementStepType.PAYMENT>,
    public readonly addedSignatureId?: string,
  ) { }
}

export class SaveEngagementLetter {
  static readonly type = '[EngagementsState] SaveEngagementLetter';

  constructor(public readonly updatedEngagementLetterData: string) { }
}

export class SaveConsentDocument {
  static readonly type = '[EngagementsState] SaveConsentDocument';

  constructor(public readonly updatedDocumentData: string, public readonly consent: ConsentResponse) {}
}

export class ConfirmConsentDocument {
  static readonly type = '[EngagementsState] ConfirmConsentDocument';

  constructor(public readonly updatedDocumentData: string) {}
}

export class ConfirmPaymentInfo {
  static readonly type = '[EngagementsState] ConfirmPaymentInfo';

  constructor(public readonly paymentMethod?: EngagementPaymentMethod) { }
}

// Will this need to be changed?
export class RecoverFromEngagementCompletionFailure {
  static readonly type = '[EngagementsState] RecoverFromEngagementCompletionFailure';

  constructor(public readonly stepSubmissionError: any) { }
}

// Will this need to be changed?
export class SetEngagementStepPendingChanges {
  static readonly type = '[EngagementsState] SetEngagementStepPendingChanges';

  constructor(public engagementId: number, public stepType: EngagementStepType, public pendingChanges: EngagementStepPendingChanges) { }
}

export class RemoveEngagementStepPendingChanges {
  static readonly type = '[EngagementsState] RemoveEngagementStepPendingChanges';

  constructor(public engagementId: number, public stepType?: EngagementStepType) { }
}

export class LoadMultipleIdentitySigningData {
  static readonly type = '[EngagementsState] LoadMultipleIdentitySigningData';

  constructor(public documentContactMappings: EngagementDocumentContactMapping[], public contactIds: number[]) { }
}

export class SetActiveSigningContact {
  static readonly type = '[EngagementsState] SetActiveSigningContact';

  constructor(public contactId: number) { }
}

export class SaveEngagementLetterMultiContact {
  static readonly type = '[EngagementsState] SaveEngagementLetterMultiContact';

  constructor(public readonly updatedEngagementLetterData: string) { }
}

export class SaveConsentDocumentMultiContact {
  static readonly type = '[EngagementsState] SaveConsentDocumentMultiContact';

  constructor(public readonly updatedDocumentData: string, public readonly consent: ConsentResponse) { }
}

export class ConfirmConsentDocumentMultiContact {
  static readonly type = '[EngagementsState] ConfirmConsentDocumentMultiContact';
}
